module.exports = __webpack_public_path__ + "static/media/3-dots.b57b7dbc.svg";